import { render, staticRenderFns } from "./ShowcaseAutomation.vue?vue&type=template&id=f53b2526&scoped=true&"
import script from "./ShowcaseAutomation.vue?vue&type=script&lang=js&"
export * from "./ShowcaseAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53b2526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
